import cn from 'classnames';
import React, { memo } from 'react';

import { Link } from 'components';
import { Row } from 'components/layout';
import CardLogo from 'components/candidate/CardLogo';

import styles from './CompanyCard.module.scss';

export interface CompanyCardProps {
  id: string;
  name: string;
  icon_url: string;
  is_verified: boolean;
  huzzle_verified: boolean;
  industry: string;
  city: string;
  url: string;
}

export const CompanyCard: React.FC<CompanyCardProps> = memo(
  ({
    name,
    icon_url,
    is_verified,
    huzzle_verified,
    industry,
    url,
    city,
  }: CompanyCardProps) => {
    const contentClassNames = cn({
      [styles.CompanyCard]: true,
    });

    return (
      <Link
        href={url}
        underlineOnHover={false}
        className={styles.link}
        target="_blank"
      >
        <div className={contentClassNames} data-testid="CompanyCard">
          <CardLogo
            is_verified={is_verified}
            huzzle_verified={huzzle_verified}
            logo_url={icon_url}
            initials={name.substring(0, 1).toUpperCase()}
            size={'large'}
            className={styles.logo}
            verifiedClassName={styles.icon}
            cohostsLogoDetails={null}
          />

          <div>
            <p className={styles.title}>{name}</p>
            <Row className={styles.detailRow}>
              <div>
                {industry}
                {city ? (
                  <>
                    <span className={styles.dot}>•</span>
                    {city}
                  </>
                ) : null}
              </div>
            </Row>
          </div>
        </div>
      </Link>
    );
  }
);

CompanyCard.displayName = 'TouchpointCard';
